import { StyledModalBodyT1 } from "./Body.styles";

/**
 * ModalBodyT1
 *
 * Styled wrapper for modal body content.
 *
 * Params
 * - children (React.ReactNode): The content to render inside the modal body.
 * - ...rest (object): Additional props forwarded to the StyledModalBodyT1 component.
 *
 * Returns
 * - React.ReactElement: A StyledModalBodyT1 element wrapping the provided children.
 */
const ModalBodyT1 = ({ children, ...props }) => {
  return <StyledModalBodyT1 {...props}>{children}</StyledModalBodyT1>;
};

export { ModalBodyT1 };
